"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const any_1 = require("../any");
/*
 * Parse the given string or number as a date. Returns undefined if date could
 * not be parsed.
 *
 * @Param {string | number} date = The date string or unix number to parse.
 *
 * @Example
 *
 *     parseDate('2018-01-01')
 *     //=> Mon Jan 01 2018 00:00:00 GMT+0000 (Greenwich Mean Time) {}
 *
 *     parseDate(0)
 *     //=> Thu Jan 01 1970 01:00:00 GMT+0100 (Greenwich Mean Time)
 *
 *     parseDate('gibberish')
 *     //=> undefined
 */
function parseDate(date) {
    if (any_1.isMissing(date)) {
        return undefined;
    }
    const parsedDate = new Date(date);
    if (Number.isNaN(parsedDate.getTime())) {
        return undefined;
    }
    return parsedDate;
}
exports.parseDate = parseDate;
//# sourceMappingURL=parse-date.js.map